export enum URLs {
     //WebSiteTermURL's
     WebSiteTermGBEN = 'https://www.ups.com/gb/en/support/shipping-support/legal-terms-conditions.page',
     WebSiteTermDEEN = 'https://www.ups.com/de/en/support/shipping-support/legal-terms-conditions.page?WT.svl=Footer',
     WebSiteTermDEDE = 'https://www.ups.com/de/de/support/shipping-support/legal-terms-conditions.page',
     //Website Term of Use URL's
     WebSiteTermofUseDEEN ='https://www.ups.com/de/en/support/shipping-support/legal-terms-conditions/website-terms-of-use.page',
     WebSiteTermofUseDEDE = 'https://www.ups.com/de/de/support/shipping-support/legal-terms-conditions.page',
     WebSiteTermofUseITIT = 'https://www.ups.com/it/it/support/shipping-support/legal-terms-conditions/website-terms-of-use.page',
     WebSiteTermofUseITEN = 'https://www.ups.com/it/en/support/shipping-support/legal-terms-conditions/website-terms-of-use.page',
     WebSiteTermofUseFRFR = 'https://www.ups.com/fr/fr/support/shipping-support/legal-terms-conditions/website-terms-of-use.page',
     WebSiteTermofUseFREN = 'https://www.ups.com/fr/en/support/shipping-support/legal-terms-conditions/website-terms-of-use.page',
     WebSiteTermofUseGBEN = 'https://www.ups.com/gb/en/support/shipping-support/legal-terms-conditions.page',
     //ProductDisclosureURL's
     ProductDisclosureGBEN = 'https://upscapital.com/gb-en/product-disclosures/',   
       
     ProductDisclosureDEEN = 'https://upscapital.com/de-en/product-disclosures/',
     ProductDisclosureDEDE = 'https://upscapital.com/de-de/product-disclosures/',
     ProductDisclosureITIT = 'https://upscapital.com/it-it/product-disclosures/',
     ProductDisclosureITEN = 'https://upscapital.com/it-en/product-disclosures/',
     ProductDisclosureFRFR = 'https://upscapital.com/fr-fr/product-disclosures/',
     ProductDisclosureFREN = 'https://upscapital.com/fr-en/product-disclosures/',

     //ComplaintsURL's
     ComplaintsGBEN = 'https://upscapital.com/gb-en/complaints/',
     ComplaintsDEEN = 'https://upscapital.com/de-en/complaints/',
     ComplaintsDEDE = 'https://upscapital.com/de-de/complaints/',
     ComplaintsITIT = 'https://upscapital.com/it-it/complaints/',
     ComplaintsITEN = 'https://upscapital.com/it-en/complaints/',
     ComplaintsFRFR = 'https://upscapital.com/fr-fr/complaints/',
     ComplaintsFREN = 'https://upscapital.com/fr-en/complaints/',
   
     
     //LegalNoticeURL's
     LegalNoticeDEEN = 'https://upscapital.com/de-en/impressum/',
     LegalNoticeDEDE = 'https://upscapital.com/de-de/impressum/',

     //PrivacyNoticeURL's
     PrivacyNoticeGBEN = 'https://upscapital.com/gb-en/privacy-notice/',     
     PrivacyNoticeDEEN = 'https://upscapital.com/de-en/privacy-notice/',
     PrivacyNoticeDEDE = 'https://upscapital.com/de-de/privacy-notice/',
     PrivacyNoticeITIT = 'https://upscapital.com/it-it/privacy-notice/',
     PrivacyNoticeITEN = 'https://upscapital.com/it-en/privacy-notice/',
     PrivacyNoticeFRFR = 'https://upscapital.com/fr-fr/privacy-notice/',
     PrivacyNoticeFREN = 'https://upscapital.com/fr-en/privacy-notice/',
     
     //TechnologyAgreementURL's
     TechnologyAgreementDEDE = 'https://upscapital.com/de-de/international-technology-agreement/',
     TechnologyAgreementDEEN = 'https://upscapital.com/de-en/international-technology-agreement/',
     TechnologyAgreementGBEN = 'https://upscapital.com/gb-en/international-technology-agreement/',
     TechnologyAgreementFRFR = 'https://upscapital.com/fr-fr/international-technology-agreement/',
     TechnologyAgreementFREN = 'https://upscapital.com/fr-en/international-technology-agreement/',
     TechnologyAgreementITIT = 'https://upscapital.com/it-it/international-technology-agreement/',
     TechnologyAgreementITEN = 'https://upscapital.com/it-en/international-technology-agreement/',
     //Impressum URL's
     ImpressumDE = 'https://upscapital.com/de-de/impressum/',
     ImpressumEN= 'https://upscapital.com/de-en/impressum/',
  }
